// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useLocalSearchParams } from 'expo-router';
import { View, StyleSheet } from 'react-native';

import { Text } from '@/components/Themed';
import { useI18n } from '@/i18n';
import TourPhotosScreen from '@/features/tour-photos/screen/TourPhotosScreen';
import appColors from '@/theme/colors';

export default function TourPhotosRoute() {
  // `roundId` opens the gallery already filtered to one round. Entry points that are themselves
  // round-scoped — the round settings and results screens, and the single-round rows in Tour &
  // Rounds — pass it so you land on that round's photos rather than the whole tour's.
  const { tourId, roundId } = useLocalSearchParams<{ tourId?: string; roundId?: string }>();
  const { t } = useI18n();

  if (!tourId) {
    return (
      <View style={styles.errorContainer}>
        <Text style={styles.errorText}>{t('tourPhotos.tourNotFound')}</Text>
      </View>
    );
  }

  return <TourPhotosScreen tourId={tourId} initialRoundId={roundId ?? null} />;
}

const styles = StyleSheet.create({
  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: appColors.background.app,
  },
  errorText: {
    fontSize: 16,
    color: appColors.status.danger,
    fontWeight: '600',
  },
});
